import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const ContentPricePolicyPage = lazy(() => import('@/pages/policy/content/ContentPricePolicyPage'))
const BonusPolicyPage = lazy(() => import('@/pages/policy/bonus/BonusPolicyPage'))
const PaymentPolicyPage = lazy(() => import('@/pages/policy/payment/PaymentPolicyPage'))

/**
 *  판매 정책 라우트
 * - 콘텐츠
 * - 보너스
 * - 푸딩 결제
 */

export const policyRoutes: RouteWithMeta = {
  path: 'policy',
  meta: {
    label: '판매 정책',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 콘텐츠 =====
    {
      path: 'content-price',
      element: withSuspense(<ContentPricePolicyPage/>),
      meta: {
        label: '콘텐츠',
        showInMenu: true,
      }
    },

    // ===== 보너스 =====
    {
      path: 'bonus',
      element: withSuspense(<BonusPolicyPage/>),
      meta: {
        label: '보너스',
        showInMenu: true,
      },
    },

    // ===== 푸딩 결제 =====
    {
      path: 'payment',
      element: withSuspense(<PaymentPolicyPage/>),
      meta: {
        label: '푸딩 결제',
        showInMenu: true,
      }
    },
  ]
}